/**
 * @generated SignedSource<<6216aa4a0b566116340c41887fe7eaf7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteInvitationPayload",
    "kind": "LinkedField",
    "name": "deleteInvitation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteInvitationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteInvitationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e536e3e1e7609c0340c7c4a8f62a8e7e",
    "id": null,
    "metadata": {},
    "name": "DeleteInvitationMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteInvitationMutation(\n  $input: DeleteInvitationInput!\n) {\n  deleteInvitation(input: $input) {\n    deletedId\n  }\n}\n"
  }
};
})();

node.hash = "df084afe3915e762d618af90a4998651";

export default node;
